__turbopack_context__.v({
  "drawFacts": "1-module__xjFTma__drawFacts",
  "entriesContainer": "1-module__xjFTma__entriesContainer",
  "entryCountPicker": "1-module__xjFTma__entryCountPicker",
  "entryCountTabBar": "1-module__xjFTma__entryCountTabBar",
  "entryList": "1-module__xjFTma__entryList",
  "infoButton": "1-module__xjFTma__infoButton",
  "luckyNumberInfoIcon": "1-module__xjFTma__luckyNumberInfoIcon",
  "tabBarBadge": "1-module__xjFTma__tabBarBadge",
  "tabBarButton": "1-module__xjFTma__tabBarButton",
  "tabBarButtonSelected": "1-module__xjFTma__tabBarButtonSelected",
  "tabBarSubtext": "1-module__xjFTma__tabBarSubtext",
  "winnerImage": "1-module__xjFTma__winnerImage",
});
